import { Routes } from "@angular/router"
import { clerkAuthGuard } from "./core/guards/clerk-auth.guard"

export const routes: Routes = [
  {
    path: "",
    redirectTo: "home",
    pathMatch: "full",
  },
  {
    path: "home",
    loadComponent: () => import("./home/home.component").then((m) => m.HomeComponent),
    title: "Home",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "documents/:id",
    loadComponent: () =>
      import("./documents/document-viewer/document-viewer.component").then(
        (m) => m.DocumentViewerComponent,
      ),
    title: "Document",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "documents",
    loadComponent: () =>
      import("./documents/documents-page/documents-page.component").then(
        (m) => m.DocumentsPageComponent,
      ),
    title: "Documents",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "transactions",
    loadComponent: () =>
      import("./transactions/transactions-page/transactions-page.component").then(
        (m) => m.TransactionsPageComponent,
      ),
    title: "Transactions",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "transactions/pending-links",
    loadComponent: () =>
      import("./transactions/pending-links-page/pending-links-page.component").then(
        (m) => m.PendingLinksPageComponent,
      ),
    title: "Pending Links",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "transactions/duplicates",
    loadComponent: () =>
      import("./transactions/duplicate-review-page/duplicate-review-page.component").then(
        (m) => m.DuplicateReviewPageComponent,
      ),
    title: "Find Duplicates",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "transactions/:id",
    loadComponent: () =>
      import("./transactions/transactions-page/transactions-page.component").then(
        (m) => m.TransactionsPageComponent,
      ),
    title: "Transaction",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "patterns",
    loadComponent: () =>
      import("./patterns/recurring-pattern-list/recurring-pattern-list.component").then(
        (m) => m.RecurringPatternListComponent,
      ),
    title: "Recurring Patterns",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "loans",
    loadComponent: () =>
      import("./features/loans/loan-list/loan-list.component").then((m) => m.LoanListComponent),
    title: "Loans",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "recurring-invoices/new",
    loadComponent: () =>
      import("./features/invoices/recurring-invoice-form/recurring-invoice-form.component").then(
        (m) => m.RecurringInvoiceFormComponent,
      ),
    title: "New Recurring Invoice",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "recurring-invoices/:id/edit",
    loadComponent: () =>
      import("./features/invoices/recurring-invoice-form/recurring-invoice-form.component").then(
        (m) => m.RecurringInvoiceFormComponent,
      ),
    title: "Edit Recurring Invoice",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "recurring-invoices",
    loadComponent: () =>
      import("./features/invoices/recurring-invoice-list/recurring-invoice-list.component").then(
        (m) => m.RecurringInvoiceListComponent,
      ),
    title: "Recurring Invoices",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "invoices/new",
    loadComponent: () =>
      import("./features/invoices/invoice-form/invoice-form.component").then(
        (m) => m.InvoiceFormComponent,
      ),
    title: "New Invoice",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "invoices/:id/edit",
    loadComponent: () =>
      import("./features/invoices/invoice-form/invoice-form.component").then(
        (m) => m.InvoiceFormComponent,
      ),
    title: "Edit Invoice",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "invoices",
    loadComponent: () =>
      import("./features/invoices/invoice-list/invoice-list.component").then(
        (m) => m.InvoiceListComponent,
      ),
    title: "Invoices",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "invoices/:id",
    loadComponent: () =>
      import("./features/invoices/invoice-form/invoice-form.component").then(
        (m) => m.InvoiceFormComponent,
      ),
    title: "Invoice",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "accounts",
    loadComponent: () =>
      import("./accounts/accounts-page/accounts-page.component").then(
        (m) => m.AccountsPageComponent,
      ),
    title: "Accounts",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "balances",
    loadComponent: () =>
      import("./accounts/balance-management-page/balance-management-page.component").then(
        (m) => m.BalanceManagementPageComponent,
      ),
    title: "Balance Management",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "ledger",
    loadComponent: () =>
      import("./ledger/ledger-page/ledger-page.component").then((m) => m.LedgerPageComponent),
    title: "Ledger",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "journal",
    loadComponent: () =>
      import("./journal/journal-page/journal-page.component").then((m) => m.JournalPageComponent),
    title: "Journal",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "journal/generate",
    loadComponent: () =>
      import("./journal/journal-generate/journal-generate.component").then(
        (m) => m.JournalGenerateComponent,
      ),
    title: "Generate Journal",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "assets",
    loadComponent: () =>
      import("./assets/asset-list/asset-list.component").then((m) => m.AssetListComponent),
    title: "Assets",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "contacts",
    loadComponent: () =>
      import("./contacts/contacts-page/contacts-page.component").then(
        (m) => m.ContactsPageComponent,
      ),
    title: "Contacts",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "contacts/:id",
    loadComponent: () =>
      import("./contacts/contact-detail/contact-detail.component").then(
        (m) => m.ContactDetailComponent,
      ),
    title: "Contact",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "entities",
    loadComponent: () =>
      import("./entities/entities-page/entities-page.component").then(
        (m) => m.EntitiesPageComponent,
      ),
    title: "Entities",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "institutes",
    loadComponent: () =>
      import("./features/institutes/institutes-page.component").then(
        (m) => m.InstitutesPageComponent,
      ),
    title: "Financial Institutes",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "categories",
    loadChildren: () => import("./categories/categories.routes").then((m) => m.CATEGORY_ROUTES),
    title: "Categories",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "rules",
    loadChildren: () => import("./rules/rules.routes").then((m) => m.RULES_ROUTES),
    title: "Categorization Rules",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "analysis",
    loadChildren: () => import("./analysis/analysis.routes").then((m) => m.ANALYSIS_ROUTES),
    title: "Analysis",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "mandates",
    loadChildren: () =>
      import("./features/mandates/mandates.routes").then((m) => m.MANDATES_ROUTES),
    title: "Direct Debits",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "reports",
    title: "Reports",
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./features/reports/report-list/report-list.component").then(
            (m) => m.ReportListComponent,
          ),
      },
      {
        path: "generate/:code",
        loadComponent: () =>
          import("./features/reports/report-generate/report-generate.component").then(
            (m) => m.ReportGenerateComponent,
          ),
        title: "Generate Report",
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./features/reports/report-view/report-view.component").then(
            (m) => m.ReportViewComponent,
          ),
        title: "View Report",
      },
    ],
    canActivate: [clerkAuthGuard],
  },
  {
    path: "email-ingestion",
    loadComponent: () =>
      import("./features/email-settings/email-settings-page/email-settings-page.component").then(
        (m) => m.EmailSettingsPageComponent,
      ),
    title: "Email Processing",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "style-guide",
    loadComponent: () =>
      import("./style-guide/style-guide.component").then((m) => m.StyleGuideComponent),
    title: "Style Guide",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "admin",
    loadChildren: () => import("./admin/admin.routes").then((m) => m.ADMIN_ROUTES),
    title: "Administration",
    canActivate: [clerkAuthGuard],
  },
  {
    path: "verify-email",
    loadComponent: () =>
      import("./features/email-verification/verify-email-page.component").then(
        (m) => m.VerifyEmailPageComponent,
      ),
    title: "Verify Email",
    // No canActivate — public route for email senders clicking verification links
  },
  {
    path: "**",
    redirectTo: "transactions",
  },
]
